import { render } from "./base-dropdown.vue?vue&type=template&id=85b0a2d8&ts=true"
import script from "./base-dropdown.vue?vue&type=script&lang=ts"
export * from "./base-dropdown.vue?vue&type=script&lang=ts"

import "./base-dropdown.vue?vue&type=style&index=0&id=85b0a2d8&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__